import TextField from '@mui/material/TextField';
import { useState } from 'react';
import globals from '../globals';


const TextFieldRedBackground = ({
    labelName,
    idName,
    helperText,
    inputProps,
    onChange,
    value: controlledValue,
    size = 'medium',
    fullWidth = true,
    sx = {},
}) => {
    const [focused, setFocused] = useState(false);
    const [internalValue, setInternalValue] = useState('');
    const [error, setError] = useState(false);
    const isControlled = controlledValue !== undefined;
    const value = isControlled ? controlledValue : internalValue;

    const handleChange = (e) => {
        if (!isControlled) {
            setInternalValue(e.target.value);
        }
        if (onChange) {
            onChange(e);
        }
        if (e.target.validity.valid) {
            setError(false);
        } else {
            setError(true);
        }
    }

    return (
        <TextField
            required
            autoComplete='off'
            fullWidth={fullWidth}
            id={idName}
            label={focused || value ? '' : labelName}
            // variant="outlined"
            value={value}
            size={size}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={handleChange}
            error={error}
            helperText={
                error ? helperText : ""
            }
            inputProps={
                inputProps
            }
            sx={{
                // width: '100vh',
                borderRadius: 1,
                '& .MuiOutlinedInput-root': {
                    '& .MuiInputBase-input': {
                        borderRadius: 1,
                        backgroundColor: globals.colors.lightPink,
                    },
                    '& fieldset': {
                        borderColor: 'transparent', // no border by default
                    },
                    '&:hover fieldset': {
                        borderColor: 'transparent', // no border on hover
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: globals.colors.lightRed, // red border when typing
                    },
                },
                ...(sx || {}),
            }}
        />
    );
};

export default TextFieldRedBackground;